import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const DeptCategoryForm = ({ deptcategoryId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [deptcategoryName, setDeptCategoryName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.dept_category) {
               setDeptCategoryName(initialData.dept_category);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!deptcategoryName.trim()) {
               setError('dept category name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (deptcategoryId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateDeptCategoryById/${deptcategoryId}`;
                    body = { dept_category: deptcategoryName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createDeptCategory`;
                    body = { deptcategory: deptcategoryName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(deptcategoryId ? 'Dept category updated successfully' : 'Dept category created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/deptcategory');
               } else {
                    setError(data.message || `Failed to ${deptcategoryId ? 'update' : 'create'} DEPTCATEGORY`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };
     const handleCloseModal = () => {
          navigate('/deptcategory');
     };




     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title">{deptcategoryId ? 'Edit Dept Category' : 'Add Dept Category'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="deptcategoryName"
                              placeholder=" "
                              autoComplete="off"
                              value={deptcategoryName}
                              onChange={(e) => setDeptCategoryName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="deptcategoryName">Dept Category Name</label>
                    </div>
               </div>
               <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    <button
                         type="submit"
                         className="btn btn-primary"

                         disabled={loading}
                    >
                         {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button
                         type="button"

                         className="btn btn-secondary"
                         onClick={handleCloseModal}
                         disabled={loading}
                    >
                         Cancel
                    </button>
               </div>

          </form>
     );
};

export default DeptCategoryForm;
